import { useFragment } from '@apollo/client';
import { t } from '@lingui/core/macro';
import { Box, EmptyState } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useACLCan } from 'app/domains/filesystem/hooks/useACLCan';
import { FileSystemEmptyFolderFragmentDoc } from './FileSystemEmptyFolder.gql';
import { ContextMenuButton } from '../ContextMenuButton';
export function FileSystemEmptyFolder(props) {
    const { onUploadFile, onCreateFolder, onUploadFolder, from } = props;
    const { data, complete } = useFragment({
        from,
        fragment: FileSystemEmptyFolderFragmentDoc,
    });
    const userAcls = complete ? data === null || data === void 0 ? void 0 : data.acls : [];
    const teamAcls = complete ? data === null || data === void 0 ? void 0 : data.teamAcls : [];
    const { accessLevel } = useACLCan({ userAcls, teamAcls });
    const fullAccessDescription = t({
        message: 'Be the first one to add documents in here.',
        comment: 'Filesystem: Description for empty state when user has full access',
    });
    const description = accessLevel === 'full' ? fullAccessDescription : '';
    return (<Box flexDirection="column" justifyContent="center">
      <EmptyState withAvatar icon={<Falcon icon="folder"/>} title={t({ message: 'Empty folder', comment: 'Filesystem: Title for empty state' })} description={description} actions={accessLevel === 'full' && (<ContextMenuButton onUploadFile={onUploadFile} onCreateFolder={onCreateFolder} onUploadFolder={onUploadFolder}/>)}/>
    </Box>);
}
